<template>
  <div>
    <FilterableSelect
      defaultPlaceholder="Quincena"
      :defaultValue="QuincenaSelected"
      :inheritedOptions="QuincenaList"
      @updateValue="handleSelection"
    />
  </div>
</template>

<script>
import FilterableSelect from "@/components/Selects/filterableselect";

export default {
  name: "SelectQuincena",
  components: {
    FilterableSelect
  },
  props: {
    defaulValue: {
      required: false,
      type: [String, Number]
    }
  },
  emits: ["QuincenaSelected"],
  data() {
    return {
      QuincenaSelected: 0,
      QuincenaList: [
        { value: 0, label: "Todo el mes" },
        { value: 1, label: "Primera Quincena" },
        { value: 15, label: "Segunda Quincena" }
      ]
    };
  },
  watch: {
    defaulValue: {
      immediate: true,
      handler(newValue) {
        this.QuincenaSelected = newValue;
      }
    }
  },
  methods: {
    handleSelection(value) {
      this.QuincenaSelected = value;
      this.$emit("QuincenaSelected", this.QuincenaSelected);
    }
  }
};
</script>

<style lang="scss" scoped></style>
